/** MIME types probed with HTMLMediaElement.canPlayType(). */
export const CAN_PLAY_TYPES = {
  audio: [
    'audio/mpeg',
    'audio/mp4; codecs="mp4a.40.2"',
    'audio/aac',
    'audio/x-m4a',
    'audio/mp4; codecs="alac"',
    'audio/mp4; codecs="ac-3"',
    'audio/mp4; codecs="ec-3"',
    'audio/mp4; codecs="flac"',
    'audio/flac',
    'audio/ogg; codecs="vorbis"',
    'audio/ogg; codecs="opus"',
    'audio/webm; codecs="opus"',
    'audio/wav; codecs="1"',
  ],
  video: [
    'video/mp4; codecs="avc1.42E01E"',
    'video/mp4; codecs="hev1.1.6.L93.B0"',
    'video/mp4; codecs="hvc1.1.6.L93.B0"',
    'video/mp4; codecs="av01.0.05M.08"',
    'video/mp4; codecs="vp09.00.10.08"',
    'video/webm; codecs="vp8, vorbis"',
    'video/webm; codecs="vp9"',
    'video/webm; codecs="av01.0.05M.08"',
    'video/ogg; codecs="theora"',
    'video/quicktime',
    'video/x-matroska',
    'video/mp2t',
    'application/vnd.apple.mpegurl',
  ],
} as const;

/** Codecs probed with navigator.mediaCapabilities.decodingInfo() at 1080p30. */
export const DECODING_PROBES: Record<string, string> = {
  'H.264': 'video/mp4; codecs="avc1.640028"',
  HEVC: 'video/mp4; codecs="hvc1.1.6.L120.90"',
  VP9: 'video/webm; codecs="vp09.00.40.08"',
  AV1: 'video/mp4; codecs="av01.0.08M.08"',
};
